<template>
  <router-view />
</template>

<script>
export default {
  name: 'Secondary'
}
</script>

<style scoped>

</style>
